import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { Collage, CollageItem } from 'page/ProfileScreen/BasicSelfiesPanel/Collage'

const bad1_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-fullbody-bad-1-d5f7.jpg'
const bad2_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-fullbody-bad-2-5d44.jpg'
const bad3_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-fullbody-bad-3-cf9d.jpg'
const good1_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-fullbody-good-1-3ac6.jpg'
const good2_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-type-fullbody-1-d2c5.jpg'
const good3_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-type-fullbody-3-dbd5.jpg'

const bad_images: [CollageItem, CollageItem, CollageItem] = [
  { src: bad1_jpg, size: 'tiny' },
  { src: bad2_jpg, size: 'small' },
  { src: bad3_jpg, size: 'large' },
]

const good_images: [CollageItem, CollageItem, CollageItem] = [
  { src: good1_jpg, size: 'large' },
  { src: good2_jpg, size: 'small' },
  { src: good3_jpg, size: 'tiny' },
]

export const FullbodyExamples = observer(() => {
  return (
    <Space gap={44} center wrap>
      <Collage items={bad_images} badge="bad" back />
      <Collage items={good_images} badge="good" />
    </Space>
  )
})
